import axios from 'axios';
import settings from '../data/endpoints';
import {env} from '../utilities/environment'
import {GatewaySvc} from '../services/gateway.service';
import { BettingSvc } from '../services/betting.service';

class Results {
    /** @constructor */
    constructor() {}

    /**
     * Get results
     * data {Object}
     * @returns {Promise}
     */
    getResults(data={}){
        let DC = sevenConfig.data.company.datacenter.split('_')[1];
        let environment = env();
        let resultsUrl  = settings.results[environment][DC] + '/api_open/retail/events.json';

        let queryParams = {
            product: sevenConfig.data.product.id,
            cpvUuid: sevenConfig.data.product.cpvUuid,
            count: data.count || 10
        };

        if (data && typeof data === 'object') {
            queryParams = Object.assign(queryParams, data);
        }

        let config = {
            headers: {
                'X-Nsft-Ngs-Company': sevenConfig.data.company.uuid,
                'X-Nsft-Ngs-Product': sevenConfig.data.product.cpvUuid,
            },
            params: queryParams,
        };
        return axios.get(resultsUrl,config)
        .then( response => this.formatResults(response.data));

    }

    /**
     * Send event to master to print game results
     * @param results
     */
    printResults(results) {
        GatewaySvc.getGatewaySvc().sendMessage('Peripherals.Print', {
            action : '',
            productId: 'Keno',
            type: 'results',
            npsJobName: 'kenoResults',
            ticketData: results,
            data: results,
        });
    }

    /**
     * Format results extract special bets
     * @param results
     */
    formatResults (results) {
        const activeBetsIds = Object.values(BettingSvc.getBettingSvc().specialBets).map(({ id }) => id);
        const bets = Object.values(sevenConfig.data.config.bets);
        const specialBets = bets.filter(({ id }) => activeBetsIds.includes(id));
      
        results.forEach((round) => {
          const draw = Object.values(round.draw);
          const [firstNum, ...restNums] = Object.values(draw);
          const lastNum = restNums.pop();
          const tempSpecialBets = [];

          specialBets.forEach((bet) => {
            const { id, name, outcomes, limit } = bet;
            let value;

            switch (id) {
              case 30:
                value = firstNum < limit ? outcomes[0] : outcomes[1];
                break;
              case 31:
                value = lastNum < limit ? outcomes[0] : outcomes[1];
                break;
              case 32:
                value = firstNum < 10 ? outcomes[0] : outcomes[1];
                break;
              case 33:
                value = lastNum < 10 ? outcomes[0] : outcomes[1];
                break;
              case 34:
                value = firstNum % 2 !== 0 ? outcomes[0] : outcomes[1];
                break;
              case 35:
                value = lastNum % 2 !== 0 ? outcomes[0] : outcomes[1];
                break;
              case 36:
                value = firstNum <= 20 ? outcomes[0] : firstNum <= 40 ? outcomes[1] : firstNum <= 60 ? outcomes[2] : outcomes[3];
                break;
              case 37:
                value = lastNum <= 20 ? outcomes[0] : firstNum <= 40 ? outcomes[1] : firstNum <= 60 ? outcomes[2] : outcomes[3];
                break;
              case 38:
                const sum = draw.slice(0, 5).reduce((acc, curr) => acc + curr, 0);
                value = sum < limit ? outcomes[0] : outcomes[1];
                break;
              case 39:
                const sumTotal = draw.reduce((acc, curr) => acc + curr, 0);
                value = sumTotal < limit ? outcomes[0] : outcomes[1];
                break;
              default:
                value = null;
                break;
            }
      
            if (value !== null) {
              tempSpecialBets.push({ id, name, value });
            }
          });
      
          round.specialBets = tempSpecialBets;
        });

        return results;
      };
}


export default Results;



// WEBPACK FOOTER //
// results.js